import { endOf, startOf } from "@sembark-travel/datetime-utils"
import { THotelNote } from "./store"

export function getHotelStayDatesWithNotes(
	uniqueNotes: (THotelNote & { dates: Date[] })[],
	notes: THotelNote[],
	targetDates: Date[]
) {
	notes.flatMap((note) => {
		targetDates.forEach((date) => {
			const existingNote = uniqueNotes.find((q) => q.id === note.id)

			const isValidDate = note.date_ranges?.some(({ start_date, end_date }) => {
				const start = start_date ? startOf(start_date, "day") : null
				const end = end_date ? endOf(end_date, "day") : null

				if (start && end) return date >= start && date <= end
				if (start) return date >= start
				if (end) return date <= end
				return true
			})

			if (!existingNote) {
				// Note doesn't exist, create new
				const newNote: THotelNote & { dates: Date[] } = {
					...note,
					dates: [],
				}

				if (isValidDate) {
					newNote.dates.push(date)
				}

				uniqueNotes.push(newNote)
			} else {
				if (
					isValidDate &&
					!existingNote.dates.some((d) => d.getTime() === date.getTime())
				) {
					existingNote.dates.push(date)
				}
			}
		})
		return uniqueNotes
	})
}
